import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import translations from '@/i18n/translations';
import { Navbar } from '@/components/Navbar';
import { HeroSection } from '@/components/HeroSection';
import { AboutSection } from '@/components/AboutSection';
import { IndustriesSection } from '@/components/IndustriesSection';
import { StandardsSection } from '@/components/StandardsSection';
import { SafetySection } from '@/components/SafetySection';
import { ContactSection } from '@/components/ContactSection';
import { Footer } from '@/components/Footer';
import { AuthProvider } from '@/contexts/AuthContext';
import AdminLogin from '@/pages/AdminLogin';
import AdminLayout from '@/pages/AdminLayout';
import AdminDashboard from '@/pages/AdminDashboard';
import ContactsManager from '@/pages/ContactsManager';
import DnsMonitor from '@/pages/DnsMonitor';
import AdminUsers from '@/pages/AdminUsers';
import AnalyticsPage from '@/pages/AnalyticsPage';
import { trackPageView } from '@/lib/tracker';

function PublicSite() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const saved = localStorage.getItem('anlumax-language');
    if (saved && translations[saved]) setLanguage(saved);
    trackPageView('/');
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('anlumax-language', lang);
    document.documentElement.lang = lang;
  };

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const t = translations[language];

  return (
    <div className="min-h-screen bg-white">
      <Navbar t={t} language={language} changeLanguage={changeLanguage} scrollToSection={scrollToSection} />
      <HeroSection t={t} scrollToSection={scrollToSection} />
      <AboutSection t={t} />
      <IndustriesSection t={t} />
      <StandardsSection t={t} />
      <SafetySection t={t} />
      <ContactSection t={t} />
      <Footer t={t} scrollToSection={scrollToSection} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="contacts" element={<ContactsManager />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="dns" element={<DnsMonitor />} />
            <Route path="users" element={<AdminUsers />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
